"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    constructor() {
        super(...arguments);
        this.nav = null;
    }
    connect() {
        const navId = this.element.getAttribute("aria-controls");
        if (navId) {
            this.nav = document.getElementById(navId);
        }
        this.element.addEventListener("click", this.toggle.bind(this));
    }
    toggle(event) {
        this.element.hasAttribute("aria-expanded") ? this.hide(event) : this.show(event);
    }
    show(event) {
        this.element.setAttribute("aria-expanded", "true");
        if (this.nav) {
            this.nav.removeAttribute("data-mobile-is-hidden");
        }
    }
    hide(event) {
        this.element.removeAttribute("aria-expanded");
        if (this.nav) {
            this.nav.setAttribute("data-mobile-is-hidden", "true");
        }
    }
}
exports.default = default_1;
